var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-home-layout"},[_c('DemoTopNav'),_c('main',{staticClass:"demo-home-layout__main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }